import { Injectable } from '@angular/core';
import {DescriptorColumn, NumberDisplayType, SecondValueColumn, ValueColumn} from '../models/chart';
import {FormatOptions} from './interfaces/format-service.interface';
import {DataLanguage} from '../components/extra/data-language-control/data-language-control.component';

@Injectable()
export class ConfigFormatOptionService {

  constructor() { }

  configFormatOption(column: Partial<ValueColumn> | Partial<DescriptorColumn> |
      Partial<SecondValueColumn>, numbersDisplayType: NumberDisplayType, unit: string,
                     dataLanguage: DataLanguage, maxValue?: number, autoToFixed?: boolean): Partial<FormatOptions> {
    if (column == null) {
      return {
        numbersDisplayType,
        unit,
        dataLanguage,
        maxValue,
        autoToFixed,
      };
    }
    return {
      formatType: column.formatShow.formatType,
      columnDataModuleType: column.columnDataModuleType,
      columnAggregationType: column.columnAggregationType,
      columnDataType: column.columnDataType,
      decimalPointNumber: column.formatShow.decimalPointNumber,
      hasSeparator: column.formatShow.hasSeparator,
      negativeNumberFormat: column.formatShow.negativeNumberFormat,
      hasDollarSign: column.formatShow.hasDollarSign,
      hasPercentSign: column.formatShow.hasPercentSign,
      applyPercentage: column.formatShow.applyPercentage,
      currencyType: column.formatShow.currencyType,
      calenderType: column.formatShow.calenderType,
      dateTimeFormatType: column.formatShow.dateTimeFormatType,
      showAsPercentageOfTotal: column.showAsPercentageOfTotal,
      numbersDisplayType,
      unit,
      dataLanguage,
      maxValue,
      autoToFixed,
    };
  }
}
